import * as PIXI from "pixi.js";
import {PredefinedPIXIAnchorPoint} from "../PredefinedPIXIAnchorPoint";
import data from "./configs/data";
import {CheckBox} from "./controlElements/CheckBox";
import {GamePanel} from "./userInterface/GamePanel";

export class SettingsMenu extends PIXI.Container {

    public static getInstance(): SettingsMenu {
        if (!SettingsMenu.OBJ_INSTANCE) {
            SettingsMenu.OBJ_INSTANCE = new SettingsMenu();
        }
        return SettingsMenu.OBJ_INSTANCE;
    }

    private static OBJ_INSTANCE: SettingsMenu;

    private readonly ALWAYS_DOUBLE_UP_CHECKBOX_POSITION = new PIXI.Point(-88, -42);
    private readonly NEVER_DOUBLE_UP_CHECKBOX_POSITION = new PIXI.Point(-88, 0);
    private readonly FAST_PLAY_CHECKBOX_POSITION = new PIXI.Point(-88, 42);
    private readonly ALWAYS_DOUBLE_UP_TEXT_POSITION = new PIXI.Point(-56, -42);
    private readonly NEVER_DOUBLE_UP_TEXT_POSITION = new PIXI.Point(-56, 0);
    private readonly FAST_PLAY_TEXT_POSITION = new PIXI.Point(-56, 42);

    private readonly TEXT_STYLE = {
        fontSize: 20,
        fontFamily: "RobotoRegular",
        fill: "#fff",
    };

    private alwaysDoubleUpCheckbox: CheckBox;
    private neverDoubleUpCheckbox: CheckBox;
    private fastPlayCheckbox: CheckBox;

    private constructor() {
        super();
        this.createAndAddBackground();
        this.createAndAddAlwaysDoubleUpCheckbox();
        this.createAndAddNeverDoubleUpCheckbox();
        this.createAndAddFastPlayCheckbox();
        this.createAndAddAlwaysDoubleUpText();
        this.createAndAddNeverDoubleUpText();
        this.createAndAddFastPlayText();
        this.close();
    }

    public open(): void {
        this.visible = true;
    }

    public close(): void {
        this.visible = false;
    }

    public toggleVisibility(): void {
        if (this.visible) {
            this.close();
        } else {
            this.open();
        }
    }

    public checkSpeedCheckbox(): void {
        this.fastPlayCheckbox.checked = true;
    }

    public uncheckSpeedCheckbox(): void {
        this.fastPlayCheckbox.checked = false;
    }

    public isAlwaysDoubleUpChecked(): boolean {
        return this.alwaysDoubleUpCheckbox.checked;
    }

    public isNeverDoubleUpChecked(): boolean {
        return this.neverDoubleUpCheckbox.checked;
    }

    private createAndAddAlwaysDoubleUpText(): void {
        const text = new PIXI.Text("Always Double Up", this.TEXT_STYLE);
        text.position = this.ALWAYS_DOUBLE_UP_TEXT_POSITION;
        text.anchor = PredefinedPIXIAnchorPoint.LEFT_ALIGN;
        this.addChild(text);
    }

    private createAndAddNeverDoubleUpText(): void {
        const text = new PIXI.Text("Never Double Up", this.TEXT_STYLE);
        text.position = this.NEVER_DOUBLE_UP_TEXT_POSITION;
        text.anchor = PredefinedPIXIAnchorPoint.LEFT_ALIGN;
        this.addChild(text);
    }

    private createAndAddFastPlayText(): void {
        const text = new PIXI.Text("Fast Play", this.TEXT_STYLE);
        text.position = this.FAST_PLAY_TEXT_POSITION;
        text.anchor = PredefinedPIXIAnchorPoint.LEFT_ALIGN;
        this.addChild(text);
    }

    private createAndAddAlwaysDoubleUpCheckbox(): void {
        this.alwaysDoubleUpCheckbox = new CheckBox(data.images.settingCheckboxOffBase,
            data.images.settingCheckboxOffHover, data.images.settingCheckboxOffHover,
            data.images.settingCheckboxOffHover, data.images.settingCheckboxOnBase, data.images.settingCheckboxOnHover,
            data.images.settingCheckboxOnHover, data.images.settingCheckboxOnHover, data.audios.buttonClicked);
        this.alwaysDoubleUpCheckbox.position = this.ALWAYS_DOUBLE_UP_CHECKBOX_POSITION;
        this.alwaysDoubleUpCheckbox.subscribeOnClicked((checked: boolean) => {
            if (checked) {
                this.neverDoubleUpCheckbox.checked = false;
            }
        });
        this.addChild(this.alwaysDoubleUpCheckbox);
    }

    private createAndAddNeverDoubleUpCheckbox(): void {
        this.neverDoubleUpCheckbox = new CheckBox(data.images.settingCheckboxOffBase,
            data.images.settingCheckboxOffHover, data.images.settingCheckboxOffHover,
            data.images.settingCheckboxOffHover, data.images.settingCheckboxOnBase, data.images.settingCheckboxOnHover,
            data.images.settingCheckboxOnHover, data.images.settingCheckboxOnHover, data.audios.buttonClicked);
        this.neverDoubleUpCheckbox.position = this.NEVER_DOUBLE_UP_CHECKBOX_POSITION;
        this.neverDoubleUpCheckbox.subscribeOnClicked((checked: boolean) => {
            if (checked) {
                this.alwaysDoubleUpCheckbox.checked = false;
            }
        });
        this.addChild(this.neverDoubleUpCheckbox);
    }

    private createAndAddFastPlayCheckbox(): void {
        this.fastPlayCheckbox = new CheckBox(data.images.settingCheckboxOffBase,
            data.images.settingCheckboxOffHover, data.images.settingCheckboxOffHover,
            data.images.settingCheckboxOffHover, data.images.settingCheckboxOnBase, data.images.settingCheckboxOnHover,
            data.images.settingCheckboxOnHover, data.images.settingCheckboxOnHover, data.audios.buttonClicked);
        this.fastPlayCheckbox.position = this.FAST_PLAY_CHECKBOX_POSITION;
        this.fastPlayCheckbox.subscribeOnClicked((checked: boolean) => {
            if (checked) {
                GamePanel.getInstance().increaseSpeed();
            } else {
                GamePanel.getInstance().decreaseSpeed();
            }
        });
        this.addChild(this.fastPlayCheckbox);
    }

    private createAndAddBackground(): void {
        const background: PIXI.Sprite = PIXI.Sprite.fromImage(data.images.settingsMenuBackground);
        background.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.addChild(background);
    }
}



// WEBPACK FOOTER //
// ./src/app/SettingsMenu.ts